const messages = {
  title: 'Tilgang nektet',
  description: 'Du har ikke tilgang til denne ressursen',
  backHomeButton: 'Tilbake til dashbord'
}

export default {
  messages
}
